import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import Typography from '@mui/material/Typography';

const Countdown = (props: any) => {
  const [eventNameFontSize, setEventNameFontSize] = useState<number>(30);
  const [eventName, setEventName] = useState<string>("");
  const [dateString, setDateString] = useState<string>("");
  const [daysLeft, setDaysLeft] = useState<number>(0);

  useEffect(() => {
    setEventNameFontSize(props.eventNameFontSize);
    if (props.settingEnd) {
      setEventName(props.eventName);
      setDateString(dayjs(props.endDate).format('MMMM DD,YYYY'));
      setDaysLeft(props.endDate.diff(dayjs().startOf('day'), 'days'));  
      props.setSettingEnd(false);
    }
  }, [props.eventName, props.eventNameFontSize, props.endDate, props.settingEnd]);

  useEffect(() => {
    console.log('eventNameFontSize', eventNameFontSize);
    
  }, [eventNameFontSize]);

  interface Props {
    numberString: number;
  }
  
  const SplitNumbers: React.FC<Props> = ({ numberString }) => {
    const splitDigits = (number: number): number[] => {
      if (number === 0) {
        return [0, 0];
      }
      const numStr = number.toString();
      const digits = numStr.length > 1 ? numStr.split('').map(Number) : [0, number];
      return digits;
    }  
    const digits = splitDigits(numberString);  

    return (
      <React.Fragment>
        {(digits || []).map((digit, index) => (
          <div key={index}>{digit}</div>
        ))}
        <span>日</span>
      </React.Fragment>
    );
  };

  return (
      <Box className="event-countdown componentCore ">
        <Box className="core-color">
          <h6 style={{ fontSize: props.isIPad? (Number(eventNameFontSize) * props.scale) : eventNameFontSize }}>
            {eventName}
          </h6>
        </Box>
        <Box className="core-color">
          <Typography>
            {dateString}
          </Typography>
        </Box>
        <Box className="core-countdown">
          <SplitNumbers numberString={daysLeft} />
        </Box>
      </Box>
  );
};

export default Countdown;